"use strict";
/**
 * 小行情表格
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSmallTable = void 0;
var react_1 = __importDefault(require("react"));
var swr_1 = __importDefault(require("swr"));
var quote_1 = require("../../modules/quote");
var config_1 = require("../../modules/quote/config");
var custom_table_1 = require("./custom_table");
var addzxgbtn_1 = require("../page/shared/zxg/addzxgbtn");
/**
 * 行情小表格
 * @param props
 * @returns
 */
function QuoteSmallTable(props) {
    var tableitemconfig = custom_table_1.custom_table[props.table_key]; //表格显示配置
    //行情字段
    var quoteitemlist = tableitemconfig.filter(function (v) {
        return typeof v.value == 'number';
    }).map(function (v) { return v.value; });
    var _a = (0, swr_1.default)("quotesmalltable_".concat(props.fs, "_").concat(props.quotecode, "_").concat(props.table_key, "_").concat(props.order, "_").concat(props.orderdur), function () { return (0, quote_1.getListQuoteOrFS)({
        fs: props.fs,
        quotecode_list: props.quotecode,
        itemlist: quoteitemlist,
        fid: props.order,
        po: props.orderdur,
        pz: props.count,
        pn: 1
    }); }, {
        refreshInterval: 60 * 1000,
        dedupingInterval: 59 * 1000
    }), data = _a.data, error = _a.error;
    if (data) {
        return (react_1.default.createElement("table", { className: "box1quotetable" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, tableitemconfig.map(function (v, index) {
                    return react_1.default.createElement("th", { key: index, dangerouslySetInnerHTML: { __html: v.title } });
                }))),
            react_1.default.createElement("tbody", null, data.map(function (v, index) {
                return react_1.default.createElement("tr", { key: index }, tableitemconfig.map(function (v2, index2) {
                    var _a;
                    return react_1.default.createElement("td", { key: index2, className: (_a = v2.tdclass) !== null && _a !== void 0 ? _a : "" },
                        typeof v2.value == 'number' && v[v2.value].html,
                        v2.value == 'addzxg' &&
                            react_1.default.createElement(addzxgbtn_1.AddZXGBtn, { quotecode: v[config_1.QuoteItem.行情统一链接].source }));
                }));
            }))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null));
}
exports.QuoteSmallTable = QuoteSmallTable;
